// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Products_slider } from '../../products/products_slider.js';
import { hola_apps } from '../../install_constants.js';
import { use_was_opened } from './use_was_opened';
import styles from './products_menu.module.less';
var Products_menu = /*#__PURE__*/forwardRef((props, ref) => {
  useTranslation();
  var opened = props.opened;
  var was_opened = use_was_opened(opened);
  var cls = cn(styles.products_menu, !opened && styles.closed);
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, was_opened && /*#__PURE__*/React.createElement(Products_slider, {
    navbar_style: true,
    source: "products_menu",
    items: hola_apps,
    marked_items: {
      tv: {
        firetv: true,
        lg: true
      }
    }
  })));
});
export { Products_menu };